import type { AdminUser } from '@manaro/contracts'
import { useDueReminders } from '@/features/salons/use-salon-notes.ts'
import { useLiveSummary } from '@/features/support-chat/use-support-chat.ts'
import type { NavCounter } from '@/shared/config/navigation.ts'

/** Numbers next to sections: chats waiting for an operator, the person's own reminders due today. */
export function useNavCounters(user: AdminUser): Record<NavCounter, number> {
  const liveWaiting = useLiveSummary().data?.waiting ?? 0
  const reminders = useDueReminders(user.sections.includes('salons')).data
  return { liveWaiting, salonReminders: reminders?.available ? reminders.due.length : 0 }
}

export const COUNTER_LABELS: Record<NavCounter, string> = {
  liveWaiting: 'ждут оператора',
  salonReminders: 'напоминаний на сегодня',
}
